export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS'
export const USER_UPDATE_START = 'USER_UPDATE_START'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL'
export const RESET_PASSWORD_START = 'RESET_PASSWORD_START'
export const RESET_PASSWORD_DONE = 'RESET_PASSWORD_DONE'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'
